import { Tag } from '@cian/components';
import * as React from 'react';

import { IHiddenBaseTag } from '../../../state/tags/definitions/hidden_base';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHiddenBaseTagItemProps {
  tag: IHiddenBaseTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const HiddenBaseTagItem = (props: IHiddenBaseTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      Только видимые агентам
    </TagComponent>
  );
};
